<script context="module">
  import Badge from "./Badge.svelte";
  import BadgeDetails from "./BadgeDetails.svelte";
  import { fade, scale } from "svelte/transition";
  import Modal from "@ui/Modal.svelte";
</script>

<script lang="ts">
  export let myBadges: any[] = [];
  export let notMyBadges: never[] = [];
  export let hideDescription = false;
  export let isOpen: boolean = false;

  let showAllBadges = false;

  function close() {
    isOpen = false;
  }

  $: allBadges = [...myBadges, ...notMyBadges];
  $: badgesToShow = allBadges.slice(0, 23);
  const badgesPerRowArray = [7, 6, 7];

  function showAllBadgesPopup() {
    showAllBadges = true;
  }
  function hideAllBadgesPopup() {
    showAllBadges = false;
  }
</script>

{#each badgesPerRowArray as badgesPerRow, rowNumber}
  <div class="flex items-center justify-center w-full" class:-mt-2={rowNumber > 0}>
    {#each badgesToShow.splice(0, badgesPerRow) as badge}
      <div class="flex-shrink mb-2 ml-1 mr-1">
        <Badge {badge} badgeSize="small" active={badge.mine} />
      </div>
    {/each}
  </div>
{/each}

{#if !hideDescription}
  <div class="flex items-center justify-between mt-3">
    <div class="text-base font-medium text-teal-600 sm-clickable hover:underline" on:click={showAllBadgesPopup}>See all badges</div>
  </div>
{/if}

<Modal bind:isOpen={showAllBadges} on:close={close} --popup-width="880px" title="Smore badges">
  <i slot="icon" class="material-icons text-nxgray-300">military_tech</i>
  <div class="grid flex-wrap items-center justify-start grid-cols-2 -mx-5 -mb-5 overflow-auto rounded-b-md" style="max-height: 50vh;">
    {#each allBadges as badge}
      <div
        class="flex items-center h-32 p-4 px-6 border-b border-r badge-wrapper"
        class:bg-teal-100={myBadges.findIndex((b) => b.name === badge.name) >= 0}>
        <BadgeDetails {badge} />
      </div>
    {/each}
  </div>
</Modal>

<style>
  .badge-wrapper:nth-child(2n) {
    border-right: none;
  }
</style>
